export function matrixTransformation(data) {
    const matrixOriginal = data.twoAfcData.matrix || [];
    const participantChoices = data.twoAfcData.participantChoices || [];

    // original method labels
    const methodsOriginal = Array.from(
        new Set(
            data.twoAfcData.participantChoices.flatMap(pc => [
                pc.valueA,
                pc.valueB
            ])
        )
    );

    // sort alphabetically
    let indexed = methodsOriginal.map((m, idx) => ({ name: m, index: idx }));
    indexed.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));

    const sortedMethods = indexed.map(x => x.name);

    // reorder matrix
    const reorderedMatrix = indexed.map(r =>
        indexed.map(c => {
            const row = matrixOriginal[r.index];
            if (!row) return 0;
            const val = row[c.index];
            return Number.isFinite(val) ? val : 0;
        })
    );

    // total score
    const totalScore = {};
    sortedMethods.forEach((method, i) => {
        let score = 0;
        for (let j = 0; j < sortedMethods.length; j++) {
            if (i !== j) score += reorderedMatrix[i][j];
        }
        totalScore[method] = score;
    });

    // basic stats
    const methodCount = sortedMethods.length;
    const participantCount = new Set(participantChoices.map(c => c.participantId)).size;

    const totalComparisons = participantChoices.length;
    const maxComparisons = methodCount * methodCount * participantCount;
    const missingComparisons = maxComparisons - totalComparisons;

    const hiddenParticipants = data.twoAfcData.hiddenParticipants || new Set();
    const hiddenComparisons = data.twoAfcData.hiddenComparisons || {};

    return {
        id: data.id,
        name: data.name,

        // core data
        sortedMethods,
        methods: sortedMethods,
        matrix: reorderedMatrix,
        reorderedMatrix,

        // stats
        totalScore,
        totalComparisons,
        missingComparisons,

        // raw backend data
        participantChoices,

        // hidden state
        hiddenParticipants,
        hiddenComparisons,

        // variables
        variableA: data.variableA,
        variableB: data.variableB,
        chosenVariable: data.chosenVariable
    };
}
